import AWN from 'awesome-notifications'

export const notify = error => {
  let errorMsg = null

  if (error.response && Array.isArray(error.response.data.errors) && error.response.data.errors[0]) {
    const err = error.response.data.errors[0]
    if (err.error_id === '1000') errorMsg = 'Vnešeni so bili neveljavni ali nepopolni podatki.'
    if (err.error_id === '1000custom') errorMsg = 'Vnešeni so bili neveljavni podatki:<br />-za isti artikel lahko obstaja le en zapis<br />-preverite vnešeno količino posameznih artiklov'
    if (err.error_id === '1001') errorMsg = 'Velikost vnešenih podatkov presega dovojeno mejo.'
    if (err.error_id === '1002') errorMsg = 'V bazi že obstaja zapis s temi podatki.'
    if (err.error_id === '1003') errorMsg = 'Podatki so v uporabi.'
    if (err.error_id === '1004') errorMsg = 'Gesli se ne ujemata.'
    if (err.error_id === '1005') errorMsg = 'Akcije ne morate izvesti na svojem računu.'
    if (err.error_id === '1006') errorMsg = 'Nimate pravic za to akcijo.'
    if (err.error_id === '1007') errorMsg = 'Dodajanje podskupine ni mogoče, ker ima skupina že dodane artikle.'
    if (err.error_id === '1008') errorMsg = 'Artikel ni mogoče dodati, ker ima skupina že dodane podskupine.'
    if (err.error_id === '1009') errorMsg = 'Elementa ni mogoče dodati, ker je že doseženo maksimalno število elementov.'
    if (err.error_id === '1010') errorMsg = 'Poslovni prostor je (že) registriran.'
    if (err.error_id === '1011') errorMsg = 'Certifikat ni veljaven.'
    if (err.error_id === '1012') errorMsg = 'Komunikacija s FURSom ni uspela.'
    if (err.error_id === '1013') errorMsg = 'Certifirat podjetja ne obstaja.'
    if (err.error_id === '1014') errorMsg = 'Manjkajo podatki, obvezni za registracijo.'
    if (err.error_id === '1015') errorMsg = 'Poslovni prostor ni registriran.'
    if (err.error_id === '1016') errorMsg = 'Poslovnega prostora ni mogoče zapreti, ker ima aktivne blagajne.'
    if (err.error_id === '1017') errorMsg = 'Uporabniku manjka davčna številka.'
  }

  if (!errorMsg) {
    if (error.response) {
      if (error.response.status === 401) {
        errorMsg = `Avtorizacija je bila neuspešna.`
      }
      if (error.response.status === 403) {
        errorMsg = `Nimate potrebnih pravic za to akcijo.`
      }
      if (error.response.status === 503) {
        errorMsg = `Odgovor s strani FURSa je neveljaven.`
      }
    }
  }

  if (!errorMsg) {
    errorMsg = `Prišlo je do napake.`
  }

  new AWN({
    position: 'bottom-right',
    labels: {
      success: 'Akcija uspešna',
      warning: 'Opozorilo',
      alert: 'Napaka'
    }
  }).alert(errorMsg)
}
